import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { hasAnySim } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta04Model } from './model-consultaSeguimentoPergunta04'

export function prunePergunta04(value: ConsultaSeguimentoPergunta04Model): ConsultaSeguimentoPergunta04Model {
  return value
}

export function isPergunta04GostaDeSubirEmAllNao(
  values: ConsultaSeguimentoPergunta04Model['PERGUNTA_04_GOSTA_DE_SUBIR_EM']
): boolean {
  return (
    values?.ESCADAS === SimNaoEnum.NAO &&
    values?.CADEIRAS === SimNaoEnum.NAO &&
    values?.MOVEIS === SimNaoEnum.NAO &&
    values?.BRINQUEDOS === SimNaoEnum.NAO
  )
}

export function conditionToCalculatePergunta04(values: ConsultaSeguimentoPergunta04Model): boolean {
  return (
    isPergunta04GostaDeSubirEmAllNao(values?.PERGUNTA_04_GOSTA_DE_SUBIR_EM) ||
    hasAnySim(values?.PERGUNTA_04_GOSTA_DE_SUBIR_EM)
  )
}

export function calculateResultadoPergunta04(values: ConsultaSeguimentoPergunta04Model): PassouFalhouEnum | undefined {
  if (hasAnySim(values?.PERGUNTA_04_GOSTA_DE_SUBIR_EM)) {
    return PassouFalhouEnum.PASSOU
  }
  if (isPergunta04GostaDeSubirEmAllNao(values?.PERGUNTA_04_GOSTA_DE_SUBIR_EM)) {
    return PassouFalhouEnum.FALHOU
  }
}
